import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "d-flex justify-center ga-2 mb-2" }
const _hoisted_2 = { class: "avatar-wrapper" }
const _hoisted_3 = { class: "d-flex justify-center mt-4 social-wrapper" }
const _hoisted_4 = ["href"]
const _hoisted_5 = ["href"]
const _hoisted_6 = ["href"]
const _hoisted_7 = ["href"]
const _hoisted_8 = ["href"]
const _hoisted_9 = ["href"]
const _hoisted_10 = ["href"]
const _hoisted_11 = ["href"]
const _hoisted_12 = ["href"]
const _hoisted_13 = { class: "mt-4 font-weight-bold text-h6" }
const _hoisted_14 = {
  class: "mt-1 text-body-2",
  style: {"opacity":"0.8"}
}
const _hoisted_15 = ["innerHTML"]

import { ref, computed } from 'vue';
import DOMPurify from 'dompurify';
import { FounderCardProps } from './FounderCard.model';

import liquipediaIcon from '@/assets/imgs/liquipedia.png';
import youtubeIcon from '@/assets/imgs/youtube.png';
import tiktokIcon from '@/assets/imgs/tiktok.png';
import soopIcon from '@/assets/imgs/soop.png';
import twitchIcon from '@/assets/imgs/twitch.png';
import instagramIcon from '@/assets/imgs/instagram.webp';
import twitterIcon from '@/assets/imgs/twitter.png';
import redditIcon from '@/assets/imgs/reddit.png';
import w3championsIcon from '@/assets/imgs/w3c.png';

import humanIcon from '@/assets/imgs/human.webp';
import orcIcon from '@/assets/imgs/orc.webp';
import undeadIcon from '@/assets/imgs/undead.webp';
import nightelfIcon from '@/assets/imgs/nightelf.webp';


export default /*@__PURE__*/_defineComponent({
  __name: 'FounderCard',
  props: {
    id: {},
    image: {},
    name: {},
    role: {},
    race: {},
    contribution: {},
    tiktok: {},
    youtube: {},
    liquipedia: {},
    soop: {},
    twitch: {},
    instagram: {},
    twitter: {},
    reddit: {},
    w3champions: {}
  },
  setup(__props: any) {

const props = __props;

const showContribution = ref(false);

const safeContribution = computed(() => DOMPurify.sanitize(props.contribution || ''));

return (_ctx: any,_cache: any) => {
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_card, {
    elevation: "0",
    width: 350,
    variant: "text",
    class: "pa-6 d-flex flex-column align-center text-center"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (props.race.human)
          ? (_openBlock(), _createBlock(_component_v_img, {
              key: 0,
              src: _unref(humanIcon),
              width: "40",
              height: "40",
              contain: ""
            }, null, 8, ["src"]))
          : _createCommentVNode("", true),
        (props.race.orc)
          ? (_openBlock(), _createBlock(_component_v_img, {
              key: 1,
              src: _unref(orcIcon),
              width: "40",
              height: "40",
              contain: ""
            }, null, 8, ["src"]))
          : _createCommentVNode("", true),
        (props.race.undead)
          ? (_openBlock(), _createBlock(_component_v_img, {
              key: 2,
              src: _unref(undeadIcon),
              width: "40",
              height: "40",
              contain: ""
            }, null, 8, ["src"]))
          : _createCommentVNode("", true),
        (props.race.nightelf)
          ? (_openBlock(), _createBlock(_component_v_img, {
              key: 3,
              src: _unref(nightelfIcon),
              width: "40",
              height: "40",
              contain: ""
            }, null, 8, ["src"]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_v_avatar, { size: "140" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_img, {
              src: props.image,
              alt: props.name,
              cover: "",
              rounded: "circle"
            }, null, 8, ["src", "alt"])
          ]),
          _: 1
        }),
        (props.contribution)
          ? (_openBlock(), _createBlock(_component_v_btn, {
              key: 0,
              icon: "",
              variant: "flat",
              color: "primary",
              class: "avatar-contribution-btn",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (showContribution.value = true))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, {
                  size: "22",
                  color: "white"
                }, {
                  default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                    _createTextVNode("mdi-book-open-page-variant", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_3, [
        (props.tiktok)
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              href: props.tiktok,
              target: "_blank"
            }, [
              _createVNode(_component_v_img, {
                src: _unref(tiktokIcon),
                class: "social-icon-img"
              }, null, 8, ["src"])
            ], 8, _hoisted_4))
          : _createCommentVNode("", true),
        (props.youtube)
          ? (_openBlock(), _createElementBlock("a", {
              key: 1,
              href: props.youtube,
              target: "_blank"
            }, [
              _createVNode(_component_v_img, {
                src: _unref(youtubeIcon),
                class: "social-icon-img"
              }, null, 8, ["src"])
            ], 8, _hoisted_5))
          : _createCommentVNode("", true),
        (props.liquipedia)
          ? (_openBlock(), _createElementBlock("a", {
              key: 2,
              href: props.liquipedia,
              target: "_blank"
            }, [
              _createVNode(_component_v_img, {
                src: _unref(liquipediaIcon),
                class: "social-icon-img"
              }, null, 8, ["src"])
            ], 8, _hoisted_6))
          : _createCommentVNode("", true),
        (props.soop)
          ? (_openBlock(), _createElementBlock("a", {
              key: 3,
              href: props.soop,
              target: "_blank"
            }, [
              _createVNode(_component_v_img, {
                src: _unref(soopIcon),
                class: "social-icon-img"
              }, null, 8, ["src"])
            ], 8, _hoisted_7))
          : _createCommentVNode("", true),
        (props.twitch)
          ? (_openBlock(), _createElementBlock("a", {
              key: 4,
              href: props.twitch,
              target: "_blank"
            }, [
              _createVNode(_component_v_img, {
                src: _unref(twitchIcon),
                class: "social-icon-img"
              }, null, 8, ["src"])
            ], 8, _hoisted_8))
          : _createCommentVNode("", true),
        (props.instagram)
          ? (_openBlock(), _createElementBlock("a", {
              key: 5,
              href: props.instagram,
              target: "_blank"
            }, [
              _createVNode(_component_v_img, {
                src: _unref(instagramIcon),
                class: "social-icon-img"
              }, null, 8, ["src"])
            ], 8, _hoisted_9))
          : _createCommentVNode("", true),
        (props.twitter)
          ? (_openBlock(), _createElementBlock("a", {
              key: 6,
              href: props.twitter,
              target: "_blank"
            }, [
              _createVNode(_component_v_img, {
                src: _unref(twitterIcon),
                class: "social-icon-img"
              }, null, 8, ["src"])
            ], 8, _hoisted_10))
          : _createCommentVNode("", true),
        (props.reddit)
          ? (_openBlock(), _createElementBlock("a", {
              key: 7,
              href: props.reddit,
              target: "_blank"
            }, [
              _createVNode(_component_v_img, {
                src: _unref(redditIcon),
                class: "social-icon-img"
              }, null, 8, ["src"])
            ], 8, _hoisted_11))
          : _createCommentVNode("", true),
        (props.w3champions)
          ? (_openBlock(), _createElementBlock("a", {
              key: 8,
              href: props.w3champions,
              target: "_blank"
            }, [
              _createVNode(_component_v_img, {
                src: _unref(w3championsIcon),
                class: "social-icon-img"
              }, null, 8, ["src"])
            ], 8, _hoisted_12))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_13, _toDisplayString(props.name), 1),
      _createElementVNode("div", _hoisted_14, _toDisplayString(props.role), 1),
      _createVNode(_component_v_dialog, {
        modelValue: showContribution.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((showContribution).value = $event)),
        "max-width": "600"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_title, { class: "mt-2 text-h6 w-full d-flex align-center justify-center" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(props.name) + " — Contribution ", 1)
                ]),
                _: 1
              }),
              _createVNode(_component_v_card_text, null, {
                default: _withCtx(() => [
                  _createElementVNode("div", { innerHTML: safeContribution.value }, null, 8, _hoisted_15)
                ]),
                _: 1
              }),
              _createVNode(_component_v_card_actions, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_spacer),
                  _createVNode(_component_v_btn, {
                    variant: "text",
                    color: "primary",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (showContribution.value = false))
                  }, {
                    default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                      _createTextVNode("Close", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }))
}
}

})